module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_edupang.cac023406fb8280e4680afa15ab33c2a.png";